import { ISelectListItem } from "../models";

export enum BulkMultiselectActionsEnum {
  ADD = "ADD",
  REPLACE = "REPLACE",
  REMOVE = "REMOVE",
}

export const bulkMultiselectActions: BulkMultiselectActionsEnum[] = [
  BulkMultiselectActionsEnum.ADD,
  BulkMultiselectActionsEnum.REPLACE,
  BulkMultiselectActionsEnum.REMOVE,
];

export const bulkMultiselectActionsSelectItems: ISelectListItem[] =
  bulkMultiselectActions.map(action => ({
    value: action,
    label: action,
  }));
